<template>
  <logged-in-layout>
    <main>
      <twilio-softphone :isGhost="true" />

      <with-pusher-subscription :class="$style.content">
        <network-change-detector />
        <h1>Coaching {{repName}}</h1>
        <call-info />
        <chat-window :focus="true" :class="$style.chatWindow" :activity="activity" :request-url="requestUrl"/>
        <toolbar />
      </with-pusher-subscription>
    </main>
  </logged-in-layout>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import EventBus from '@/lib/event-bus'
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import WithPusherSubscription from './with-pusher-subscription/with-pusher-subscription'
  import NetworkChangeDetector from '../rep-call/network-change-detector/network-change-detector'
  import TwilioSoftphone from '../rep-call/twilio-softphone/twilio-softphone'
  import Toolbar from './toolbar/toolbar'
  import CallInfo from './call-info/call-info'
  import ChatWindow from '@/components/shared/chat-window/chat-window'
  import { jiminnyHost } from '@/helpers/region'

  const { mapState, mapActions } = createNamespacedHelpers('conference')

  export default {
    components: {
      LoggedInLayout,
      WithPusherSubscription,
      NetworkChangeDetector,
      TwilioSoftphone,
      Toolbar,
      CallInfo,
      ChatWindow
    },
    computed: {
      ...mapState([
        'activity'
      ]),
      repName () {
        return this.activity.from.name
      },
      requestUrl () {
        return `${jiminnyHost()}/api/v1/activity/softphone/${this.activity.id}/message`
      }
    },
    beforeDestroy () {
      this.resetState()
    },
    mounted () {
      EventBus.$emit('JOIN_CONFERENCE_CALL')
    },
    methods: mapActions([
      'resetState'
    ])
  }
</script>

<style module lang="less" src="./live-coach-call.less"></style>



// WEBPACK FOOTER //
// live-coach-call.vue?0c20875a